import { render, staticRenderFns } from "./advertoauth.vue?vue&type=template&id=535b0c2c&"
import script from "./advertoauth.vue?vue&type=script&lang=js&"
export * from "./advertoauth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports